import { Controller } from 'stimulus';
import { t } from '../../javascript/lib/i18n';

const CLASS_TOGGLE = 'amba-sortable--show-controls';
const CLASS_BTN_ACTIVE = 'active';

/**
 * Respresents a section that contains a sortable list.
 * The `toggle` action toggles the "show controls" class to the
 * list element
 */
export default class extends Controller {
  static targets = ['sortableContainer', 'toggleBtn', 'announcement'];

  toggle(event) {
    this.sortableContainerTarget.classList.toggle(CLASS_TOGGLE);

    this.toggleBtnTargets.forEach((btn) =>
      btn.classList.toggle(CLASS_BTN_ACTIVE)
    );

    const btnIsActive =
      event.currentTarget.classList.contains(CLASS_BTN_ACTIVE);

    this.toggleBtnTargets.forEach((btn) =>
      btn.setAttribute('aria-pressed', btnIsActive)
    );

    this.announcementTarget.textContent = btnIsActive
      ? t('js.sortable.mode_toggle.turned_on')
      : t('js.sortable.mode_toggle.turned_off');
  }
}
